import { FC } from 'react';
import { Dialog, Text, Flex, Button, ButtonGroup } from '@/_components';
import type { LockingConfirmationDialogProps } from './LockingConfirmationDialog.types';

export const LockingConfirmationDialog: FC<LockingConfirmationDialogProps> = ({
  isOpen,
  isLoading,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog isOpen={isOpen} onClose={onClose} title="Lock Questionnaire">
      <Dialog.Content>
        <Flex isColumn={true} gap={8}>
          <Text type="paragraph">
            Are you sure you want to lock this questionnaire? Locking prevents
            any additional edits to the questionnaire.
          </Text>
          <ButtonGroup align="right">
            <Button
              intent="secondary"
              value="Cancel"
              onClick={onClose}
              isDisabled={isLoading}
            />
            <Button
              intent="primary"
              iconLeft="lock"
              value="Lock"
              isLoading={isLoading}
              isDisabled={isLoading}
              onClick={onConfirm}
            />
          </ButtonGroup>
        </Flex>
      </Dialog.Content>
    </Dialog>
  );
};
